import React from 'react';
import PropTypes from 'prop-types';
import { Margin, Direction, Column } from '@scotia/canvas-react';
import cx from 'classnames';
import custom from './TwoColumnLayout.scss';
import { Alignment } from '../Alignment';
import MediaQuery from 'react-responsive';

const isOdd = num => num % 2 !== 0;

const TwoColumnLayout = props => {
  const arr = React.Children.toArray(props.children);
  return (
    <React.Fragment>
      <Direction key={0}>
        <Column md={6} lg={6} xs={12} sm={12}>
          <Alignment xs="left" md="left">
            {props.title}
          </Alignment>
        </Column>
      </Direction>
      <Direction>
        <MediaQuery maxWidth={921} values={window.testMediaQueryValues}>
          <Column xs={12} sm={12}>
            {arr.map(
              (el, i) =>
                i === 0 ? (
                  <div key={i}>{el}</div>
                ) : (
                  <Margin key={i} xs={24} sm={24}>
                    {el}
                  </Margin>
                )
            )}
          </Column>
        </MediaQuery>
        <MediaQuery minWidth={922} values={window.testMediaQueryValues}>
          <Column
            md={6}
            lg={6}
            className={cx({
              [custom['border-right']]: props.showVerticalDivider
            })}
          >
            {arr.filter((el, i) => !isOdd(i)).map(
              (el, i) =>
                i === 0 ? (
                  <div key={i * 2}>{el}</div>
                ) : (
                  <Margin key={i} md={24} lg={24}>
                    {el}
                  </Margin>
                )
            )}
          </Column>
          <Column md={6} lg={6}>
            {arr.filter((el, i) => isOdd(i)).map(
              (el, i) =>
                i === 0 ? (
                  <div
                    key={i * 2 + 1}
                    className={custom['data-pair-min-heigh']}
                  >
                    {el}
                  </div>
                ) : (
                  <Margin key={i} md={24} lg={24}>
                    {el}
                  </Margin>
                )
            )}
          </Column>
        </MediaQuery>
      </Direction>
    </React.Fragment>
  );
};

TwoColumnLayout.propTypes = {
  /** Title to be shown on the top */
  title: PropTypes.node.isRequired,
  /** Elements to use in the TwoColumnLayout  */
  children: PropTypes.node.isRequired,
  /** Show a vertical divider between data columns */
  showVerticalDivider: PropTypes.bool
};

TwoColumnLayout.defaultProps = {
  showVerticalDivider: false
};

export { TwoColumnLayout };
